module.exports = __webpack_public_path__ + "822780dd2e0f299bdcdb25ec967e5e1c.png";